import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { TitleResponse } from "./types";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class TitleService {
  constructor(private http: HttpClient) {}

  private titleUrl = environment.chatBackendBaseURL + "/conversation/title";

  addTitle(
    subscription_id: string,
    conversation_id: string
  ): Observable<TitleResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<TitleResponse>(
      `${this.titleUrl}/${subscription_id}`,
      { conversation_id },
      httpOptions
    );
  }

  updateTitle(
    subscription_id: string,
    conversation_id: string,
    title: string
  ): Observable<TitleResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.put<TitleResponse>(
      `${this.titleUrl}/${subscription_id}`,
      { conversation_id, title },
      httpOptions
    );
  }
}
